import SvgIcon from "@mui/material/SvgIcon";
import type { SvgIconProps } from "@mui/material/SvgIcon";

type RangeBarIconProps = SvgIconProps & {
  outerColor?: string;
  innerColor?: string;
};

const RangeBarIcon = ({ outerColor = "currentColor", innerColor = "#fff", ...props }: RangeBarIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10" fill={outerColor} />
      <circle cx="12" cy="12" r="6" fill={innerColor} />
    </SvgIcon>
  );
};

export default RangeBarIcon;
